<template>
  <v-layout column>
    <v-flex xs12>
      <cooling-load-stacked-area-plot agg="H"></cooling-load-stacked-area-plot>
    </v-flex>
    <v-flex xs12>
      <staging-profile></staging-profile>
    </v-flex>
    <v-flex xs12>
      <cooling-load-forecast-new></cooling-load-forecast-new>
    </v-flex>
  </v-layout>
</template>

<script>
import CoolingLoadStackedAreaPlot from '../components/CoolingLoadStackedAreaPlot'
import StagingProfile from '../components/StagingProfile'
import CoolingLoadForecastNew from '../components/loadforecast/CoolingLoadForecastNew'

export default {
  components: {
    CoolingLoadForecastNew,
    StagingProfile,
    CoolingLoadStackedAreaPlot,
  },
  name: 'Load',
  }
</script>

<style scoped>

</style>
